/**
 * Haptic feedback utilities for mobile devices
 * Uses the Vibration API for tactile feedback on button presses
 */

/**
 * Trigger a light haptic feedback (10ms)
 * Use for: Taps, selections, toggles
 */
export const lightHaptic = () => {
  if ('vibrate' in navigator) {
    navigator.vibrate(10);
  }
};

/**
 * Trigger a medium haptic feedback (20ms)
 * Use for: Confirmations, saves, submissions
 */
export const mediumHaptic = () => {
  if ('vibrate' in navigator) {
    navigator.vibrate(20);
  }
};

/**
 * Trigger a heavy haptic feedback (30ms)
 * Use for: Destructive actions, errors, warnings
 */
export const heavyHaptic = () => {
  if ('vibrate' in navigator) {
    navigator.vibrate(30);
  }
};

/**
 * Trigger a success haptic pattern (double tap: 10ms, 50ms gap, 10ms)
 * Use for: Successful operations, completions
 */
export const successHaptic = () => {
  if ('vibrate' in navigator) {
    navigator.vibrate([10, 50, 10]);
  }
};

/**
 * Trigger an error haptic pattern (triple tap: 20ms, 50ms gap pattern)
 * Use for: Errors, failed operations
 */
export const errorHaptic = () => {
  if ('vibrate' in navigator) {
    navigator.vibrate([20, 50, 20, 50, 20]);
  }
};
